// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Label from '../../components/Label';
import SvgIconStyle from '../../components/SvgIconStyle';
import steeringWheel from '@iconify/icons-tabler/steering-wheel';
import listBoxes from '@iconify/icons-carbon/list-boxes';
import { Icon } from '@iconify/react';
// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'general',
  //   items: [
  //     {
  //       title: 'app',
  //       path: PATH_DASHBOARD.general.app,
  //       icon: ICONS.dashboard
  //     },
  //     { title: 'e-commerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
  //     { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
  //     { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
  //     { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking }
  //   ]
  // },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      // MANAGEMENT : USER
      {
        title: 'user',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          // { title: 'profile', path: PATH_DASHBOARD.user.profile },
          // { title: 'cards', path: PATH_DASHBOARD.user.cards },
          { title: 'list', path: PATH_DASHBOARD.user.list },
          { title: 'create', path: PATH_DASHBOARD.user.newUser }
          // { title: 'edit', path: PATH_DASHBOARD.user.editById }
          // { title: 'account', path: PATH_DASHBOARD.user.account }
        ]
      }
      // {
      //   title: 'Priorities',
      //   path: PATH_DASHBOARD.priorities,
      //   icon: ICONS.analytics
      // },
      // {
      //   title: 'Operators',
      //   path: PATH_DASHBOARD.drivers,
      //   icon: <Icon icon={steeringWheel} fontSize={48} />
      // }
      // MANAGEMENT : E-COMMERCE
      // {
      //   title: 'e-commerce',
      //   path: ``,
      //   icon: ICONS.cart,
      //   children: [
      //     { title: 'shop', path: `` },
      //     { title: 'product', path: ``.productById },
      //     { title: 'list', path: `` },
      //     { title: 'create', path: ``.newProduct },
      //     { title: 'edit', path: ``.editById },
      //     { title: 'checkout', path: `` },
      //     { title: 'invoice', path: ``.invoice }
      //   ]
      // },

      // MANAGEMENT : BLOG
      // {
      //   title: 'blog',
      //   path: PATH_DASHBOARD.blog.root,
      //   icon: ICONS.blog,
      //   children: [
      //     { title: 'posts', path: PATH_DASHBOARD.blog.posts },
      //     { title: 'post', path: PATH_DASHBOARD.blog.postById },
      //     { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
      //   ]
      // }
    ]
  },

  // APP
  // ----------------------------------------------------------------------
  {
    subheader: 'app',
    items: [
      // {
      //   title: 'mail',
      //   path: ``,
      //   icon: ICONS.mail,
      //   info: <Label color="error">2</Label>
      // },
      // { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
      // { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
      {
        title: 'Report',
        path: PATH_DASHBOARD.report,
        icon: ICONS.kanban
      },
      {
        title: 'Customers',
        path: PATH_DASHBOARD.customers,
        icon: <Icon icon={listBoxes} fontSize={48} />
      }
      // {
      //   title: 'Vehicle Scheduler',
      //   path: PATH_DASHBOARD.vehicle,
      //   icon: ICONS.kanban
      // }
    ]
  }
];

export default sidebarConfig;
